import { GetterTree } from 'vuex'
import { RecordingsState } from './state'
import { RootState } from '../../state'
import { DataTableResponse, HistoryItem, RecordingItem } from '../../../models/scripts'

export const getters: GetterTree<RecordingsState, RootState> = {
  getRecordings(state): DataTableResponse {
    return state.list
  },

  getRecordingItem(state): RecordingItem | null {
    return state.item
  },

  getRecordingsHistory(state): HistoryItem[] {
    return state.history
  },

  getDownloadLink(state): string {
    return state.downloadLink
  },

  getKanbanRecordings(state): {[key: string]: {[key: string]:DataTableResponse}} {
    return state.kanban
  },
  
}
